import { createFileRoute, Navigate } from '@tanstack/react-router';
import { AlertCircle } from 'lucide-react';
import { z } from 'zod';

import { useCaregiverSmsShadowComparison } from '@apps/web/components/shared/messages/caregiver_sms_shadow';
import {
    Alert,
    AlertDescription,
    AlertTitle,
} from '@apps/web/components/ui/alert';
import { Spinner } from '@apps/web/components/ui/spinner';

export const Route = createFileRoute(
    '/_app/admin/caregiver-sms-shadow/$organizationId/$sourceMessageId',
)({
    component: CaregiverSmsShadowComparisonPage,
    head: () => ({
        meta: [{ title: 'Caregiver SMS Shadow | Phoebe Admin' }],
    }),
    validateSearch: z.object({
        organizationId: z.string().optional(),
        mode: z.enum(['live', 'sandbox']).default('live'),
    }),
});

export function CaregiverSmsShadowComparisonPage() {
    const { organizationId, sourceMessageId } = Route.useParams();
    const { mode } = Route.useSearch();
    const comparison = useCaregiverSmsShadowComparison({
        organizationId,
        sourceMessageId,
        mode,
    });
    if (comparison.data) {
        return (
            <Navigate
                to="/admin/sms-engine-runs/$runId"
                params={{ runId: comparison.data.legacy_outcome.run_id }}
                hash="shadow-comparison"
                replace={true}
            />
        );
    }

    return (
        <div className="p-6">
            {comparison.error ? (
                <Alert variant="destructive">
                    <AlertCircle />
                    <AlertTitle>Could not load comparison</AlertTitle>
                    <AlertDescription>
                        {comparison.error.message}
                    </AlertDescription>
                </Alert>
            ) : (
                <div className="text-muted-foreground flex items-center gap-2 text-sm">
                    <Spinner />
                    Loading comparison…
                </div>
            )}
        </div>
    );
}
